import React, { useCallback, useEffect, useMemo, useState } from "react";
import { LineChart } from "@mui/x-charts";
import axios from "axios";
import { DateTime } from "luxon";

const FullStat = () => {
  const devStatus = localStorage.getItem("devStatus");

  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ3aG8iOjEsInN1YiI6IjEwMTYiLCJleHAiOjE2OTg0ODY1Mzl9.-MLGYziFw7QR4i2h_Bub1yM4cYCAaS_QJR3i2VVKxsI";
  const token = localStorage.getItem("token");

  const apiLink =
    devStatus !== "production"
      ? "https://test.api.marsit.uz/api/v1"
      : "https://api.marsit.uz/api/v1";

  const from_date = DateTime.now().startOf("month").toFormat("yyyy-MM-dd");
  const till_date = DateTime.now().endOf("month").toFormat("yyyy-MM-dd");

  const [monthsList, setMonthsList] = useState([]);

  const [wpmData, setWpmData] = useState([]);

  // let monthsList2 = [];
  // let wpmScoreList = [];

  const [loading, setLoading] = useState(true);

  const getMonthlyStat = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiLink}/student/typing_statistics`, {
        params: {
          from_date,
          till_date,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const wpmScores = response.data.map((wpm) => wpm.avg_score);
      const monthData = response.data.map(
        (month) => DateTime.fromISO(month.for_date).day
      );
      setWpmData(wpmScores);
      setMonthsList(monthData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMonthlyStat();
  }, []);

  useEffect(() => {
    if (wpmData?.length && monthsList?.length) {
      setLoading(false);
    }
  }, [wpmData, monthsList]);

  return (
    <div className="stat-wrapper">
      {!loading ? (
        <LineChart
          xAxis={[
            {
              data: monthsList,
              scaleType: "point",
              label: "WPM",
            },
          ]}
          series={[
            {
              data: wpmData,
              area: true,
            },
          ]}
          width={1100}
          height={230}
          sx={{
            "& .MuiMarkElement-series-auto-generated-id-0, .MuiChartsAxis-line, .MuiChartsAxis-tick":
              {
                display: "none",
              },
            "& .MuiChartsAxis-tickLabel": {
              fill: "#9E9E9E",
              textAlign: "center",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "16px",
              letterSpacing: "0.72px",
              textTransform: "uppercase",
              marginTop: "15px",
            },
            "& .MuiAreaElement-series-auto-generated-id-0": {
              mixBlendMode: "multiply",
              opacity: "0.33",
            },
            "& .MuiLineElement-series-auto-generated-id-0 ": {
              strokeWidth: "1px",
            },
            "& .MuiChartsAxis-label": {
              color: "#424242",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "140%",
              letterSpacing: "0.2px",
              marginTop: "20px",
            },
          }}
        />
      ) : // <div>
      //   <p>{wpmData.join(', ')}</p>
      //   <p>{monthsList.join(', ')}</p>
      // </div>
      null}
      {/* <Line options={options} data={data} /> */}
    </div>
  );
};

export default FullStat;
